import { Injectable } from '@angular/core';
import {  HttpHeaders} from '@angular/common/http';
import { Observable } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { BaseUrlConstantsService } from './base-url-constants.service';
import { NgxSpinnerService } from "ngx-spinner";
import { HttpClient } from '@angular/common/http';
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'authorization': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token') || "not available",
    'token': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token') || "not available",
  })
};

import { map } from 'rxjs/operators';

const headers = { 'authorization': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token'), 'Content-Type': 'application/json' }

@Injectable({
  providedIn: 'root'
})
export class BackendApiService {
    public token : any = localStorage.getItem('token') || "not available";
    public auth : any = localStorage.getItem('token') || "not available";
    public clientTimeZone : any = localStorage.getItem('clientTimeZone') || 'not available';
    getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': localStorage.getItem('token') || 'not available',
      'token': localStorage.getItem('token') || 'not available',
      'Content-Type': 'application/json'
    });
  }
  getLogs() {
    throw new Error("Method not implemented.");
  }
  public DSPkey=BaseUrlConstantsService.DSP_KEY
  public CGkey: boolean=BaseUrlConstantsService.CG_KEY;
  constructor(private spinner: NgxSpinnerService,private httpCli: HttpClient, private toastr: ToastrService, public snackBar: MatSnackBar) { 
  }

  updateTokenOnLogin(){
    this.token = localStorage.getItem('token') || "not available";
    this.auth = localStorage.getItem('token') || "not available";
    this.clientTimeZone = localStorage.getItem('clientTimeZone') || 'not available';
  }

  showSuccess(info: any) {
    this.toastr.success(info, '', {
      timeOut: 2000
    });
  }
  showwaiting(info: any) {
    this.toastr.show(info, '', {
      timeOut: 3000
    });
  }
  showwaitingfirst(info: any) {localStorage.getItem('token')
    this.toastr.show(info, '', {
      timeOut: 2000
    });
  }

  showError(info:any) {
    this.toastr.error(info, '', {
      timeOut: 3000
    });
  }
  showYellow(info:any) {
      this.toastr.warning(info, '', 
        {
          timeOut: 3000
        }
      )
}
  getCallFor(url: string) { return this.httpCli.get(url) }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, '', {
      duration: 6000,
    });
  }

  load() {
    return new Promise(resolve => {
      this.httpCli.get('assets/country.json')
        .subscribe(data => {
          //console.log()
          resolve(data);
        });
    });
  }
loadnewData(endpoint:any){
  return new Promise(resolve=>{
    const headers = { 'authorization': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token'), 'token': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token'), 'Content-Type': 'application/json' }
    this.httpCli.get(endpoint)
    .subscribe(data=>{
      resolve(data);
    })
  })
}


loadPannelData(endpoint:any){
  return new Promise(resolve=>{
    const headers = { 'authorization': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token'), 'token': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token'), 'Content-Type': 'application/json' }
    this.httpCli.get(endpoint)
    .subscribe(data=>{
      resolve(data);
    })
  })
}

  getOfflineData() {
    return new Promise(resolve => {
      this.httpCli.get('assets/gauge_data/gaugeOfflineDataSet.json')
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  getFaultSummary() {
    return new Promise(resolve => {
      this.httpCli.get('assets/faultDetails/fault_summary.json')
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  getIndicesConstants() {
    return new Promise(resolve => {
      this.httpCli.get('assets/faultDetails/indices_conditions.json')
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  mqttConfig() {
    return new Promise(resolve => {
      this.httpCli.get('assets/mqtt_setup.json')
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  loadBeltData() {
    return new Promise(resolve => {
      this.httpCli.get('assets/belt.json')
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  industryType() {
    return new Promise(resolve => {
      this.httpCli.get('assets/industry_type.json')
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  getCheckoutTime() {
    return new Promise(resolve => {
      this.httpCli.get('assets/checkout_session.json')
        .subscribe(data => {
          resolve(data);
        });
    });
  }
  gethealthindicesbyassetid(endpoint:any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token') || "not available",
        'token': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token') || "not available",
        'timezone': localStorage.getItem('clientTimeZone') === null ? 'not available' : localStorage.getItem('clientTimeZone') || "not available"
      })
    };
    return new Promise(resolve => {
      this.httpCli.get(endpoint, httpOptions)
        .subscribe(data => {
          const res = JSON.parse(JSON.stringify(data));
          resolve(res);
        });
    });


  }
  postData(endpoint:any, body:any) {
    return new Promise(resolve => {
      const headers = { 'authorization': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token'), 
        'token': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token'), 'Content-Type': 'application/json' }
      this.httpCli.post(endpoint, body, { headers :this.getHeaders()})
        .subscribe(data => {
          const result = JSON.parse(JSON.stringify(data));
          resolve(result);
    },(err)=>{
      console.log(err)
      this.spinner.hide();
    });
    });
  }

  postTemplate(endpoint : any, body : any) {
    return new Promise(resolve => {
      const headers = { 'authorization': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token'), 'token': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token'), 'Content-Type': 'application/json' }
      this.httpCli.post(endpoint, body, { headers : this.getHeaders()})
        .subscribe(data => {
          const result = JSON.parse(JSON.stringify(data));
          resolve(result);
        });
    });
  }

  postAssetReport(endpoint : any, body : any) {
    const headers  = { 'timezone': localStorage.getItem('clientTimeZone') === null ? 'not available' : localStorage.getItem('clientTimeZone') || 'UTC',
       'authorization': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token') || "", 
       'Content-Type': 'application/json', 'token': localStorage.getItem('token') === null ? 'not available' : localStorage.getItem('token') || "" }
    return new Promise(resolve => {
      this.httpCli.post(endpoint, body, { headers })
        .subscribe(data => {
          const result = JSON.parse(JSON.stringify(data));
          resolve(result);
        });
    });
  }


  postDataSigin(endpoint : any, body : any) {
    return new Promise(resolve => {
      this.httpCli.post(endpoint, body)
        .subscribe(data => {
          const result = JSON.parse(JSON.stringify(data));
          resolve(result);
        });
    });
  }

  deleteData(endpoint :any, body: any) {
    return new Promise(resolve => {
      this.httpCli.delete(endpoint, body)
        .subscribe(data => {
          const result = JSON.parse(JSON.stringify(data));
          resolve(result);
        });
    });
  }


  deleteInfo(endpoint: any) {
    return new Promise(resolve => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': localStorage.getItem('token') || 'not available',
          'token':  localStorage.getItem('token') || 'not available',
        })
      };
      this.httpCli.delete(endpoint, httpOptions)
        .subscribe(data => {
          const result = JSON.parse(JSON.stringify(data));
          resolve(result);
        });
    });
  }

  putData(endpoint : any, body : any) {
    return new Promise(resolve => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'authorization': this.auth,
          'token': this.token
        })
      };
      this.httpCli.put(endpoint, body, httpOptions)
        .subscribe(data => {
          const result = JSON.parse(JSON.stringify(data));
          resolve(result);
        });
    });
  }


  async getData(endpoint : any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': this.auth,
        'token': this.token,
        'timezone': this.clientTimeZone
      })
    };
    return new Promise(resolve => {
      this.httpCli.get(endpoint, httpOptions)
        .subscribe(data => {
          const res = JSON.parse(JSON.stringify(data));
          resolve(res);
        });
    });
  }


  getHttpClientRes(endpoint : any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': this.auth,
        'token': this.token,
        'timezone': this.clientTimeZone
      })
    };
    return this.httpCli.get(endpoint, httpOptions).pipe(map((response: any) => response.json()));
  }

  getDataWithQuery(endpoint : any) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': this.auth,
        'token': this.token,
        'timezone': this.clientTimeZone
      })
    };
    return new Promise(resolve => {
      this.httpCli.get(endpoint, httpOptions)
        .subscribe(data => {
          const res = JSON.parse(JSON.stringify(data));
          resolve(res);
        });
    });
  }
  getDataWithQueryV2(endpoint : any) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': this.auth,
        'token': this.token,
        'timezone': this.clientTimeZone
      })
    };
    return new Promise(resolve => {
      this.httpCli.get(endpoint, httpOptions)
        .subscribe(data => {
          const res = JSON.parse(JSON.stringify(data));
          resolve(res);
        },
        error=>{
          resolve(error);
        }
      );
    });
  }


  getAllById(endpoint : any, id : any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint)
        .subscribe(data => {
          var clientsdata = JSON.parse(JSON.stringify(data));
          clientsdata = clientsdata.filter(function (o : any) { return o.clientid == id });
          resolve(clientsdata);
        });
    });
  }

  getAll(endpoint : any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint)
        .subscribe(data => {
          resolve(JSON.parse(JSON.stringify(data)));
        });
    });
  }


  getLineChartByID(endpoint: any, id: any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint)
        .subscribe(data => {
          var linechartdata = JSON.parse(JSON.stringify(data));
          linechartdata = linechartdata.filter(function (o : any) { return o.deviceid == id });
          resolve(linechartdata);
        });
    });
  }


  getLineChartTempByID(endpoint : any, id : any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint)
        .subscribe(data => {
          var linechartfortemp = JSON.parse(JSON.stringify(data));
          linechartfortemp = linechartfortemp.filter(function (o:any) { return o.deviceid == id });
          resolve(linechartfortemp);
        });
    });
  }

  saveClientSite(endpoint : any, body : any) {
    return new Promise(resolve => {
      this.httpCli.post(endpoint, body).subscribe(data => {
        var addsiteinfo = JSON.parse(JSON.stringify(data));
        resolve(addsiteinfo);
      })
    })
  }
  

  getAssetsInfoByID(endpoint : any, id : any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint).subscribe(data => {
        var assetsdata = JSON.parse(JSON.stringify(data));
        assetsdata = assetsdata.filter(function (o : any) { return o.deviceid == id });
        resolve(assetsdata);
      })
    })
  }



  getAllBySiteId(endpoint: any, id: any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint)
        .subscribe(data => {
          var clientsdata = JSON.parse(JSON.stringify(data));
          clientsdata = clientsdata.filter(function (o:any) { return o.siteid == id });
          resolve(clientsdata);
        });
    });
  }


  getAllByGroupId(endpoint : any, id : any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint)
        .subscribe(data => {
          var clientsdata = JSON.parse(JSON.stringify(data));
          clientsdata = clientsdata.filter(function (o : any) { return o.groupid == id });
          resolve(clientsdata);
        });
    });
  }


  getGroupsByUserID(endpoint : any, id :any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint)
        .subscribe(data => {
          var clientsdata = JSON.parse(JSON.stringify(data));
          clientsdata = clientsdata.filter(function (o: any) { return o.userid == id });
          resolve(clientsdata);
        });
    });
  }

  getSitesByUserID(endpoint: any, id : any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint)
        .subscribe(data => {
          var clientsdata = JSON.parse(JSON.stringify(data));
          clientsdata = clientsdata.filter(function (o: any) { return o.clientid == id });
          resolve(clientsdata);
        });
    });
  }


  getAllByUserId(endpoint: any, id:any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint)
        .subscribe(data => {
          var clientsdata = JSON.parse(JSON.stringify(data));
          clientsdata = clientsdata.filter(function (o:any) { return o.clientid == id });
          resolve(clientsdata);
        });
    });
  }


  addUserPost(endpoint : any, body : any) {
    return new Promise(resolve => {
      this.httpCli.post(endpoint, body)
        .subscribe(data => {
          var res = JSON.parse(JSON.stringify(data));
          resolve(res);
        });
    })
  }


  getInfo(endpoint : any, id : any) {
    return new Promise(resolve => {
      this.httpCli.get(endpoint)
        .subscribe(data => {
          var userdata = JSON.parse(JSON.stringify(data));
          userdata = userdata.filter(function (o:any) { return o.id == id });
          resolve(userdata[0]);
        });
    });
  }


  load_US_CANADA_Citys() {
    return new Promise(resolve => {
      this.httpCli.get('assets/us_canada_citys.json').subscribe(data => {
        resolve(data);
      });
    });
  }
//here
  // loadDeviceCloudApis() {
  //  if(this.DSPkey==true){
  //   console.log("in DSPPPacloudapi")
  //   return new Promise(resolve => {
  //     this.httpCli.get('assets/cloud_api_config_DSP.json').subscribe(data => {

  //       resolve(data);
  //     });
  //   });

  //  }
  //  else if(this.CGkey==true){
  //   return new Promise(resolve => {
  //     this.httpCli.get('assets/cloud_api_config_CG.json').subscribe(data => {

  //       resolve(data);
  //     });
  //   });

  //  }
  //  else{
  //   return new Promise(resolve => {
  //     this.httpCli.get('assets/cloud_api_config.json').subscribe(data => {
  //       resolve(data);
  //     });
  //   });

  //  }

  // }

  loadWeekDays() {
    return new Promise(resolve => {
      this.httpCli.get('assets/day.json').subscribe(data => {
        resolve(data);
      });
    });
  }

  getCall(url: string) {
    return this.httpCli.get(url);
  }
  getOEMUser() {
    return new Promise(resolve => {
      this.httpCli.get('assets/OEM.json')
        .subscribe(data => {
          resolve(data);
        });
    });
  }

  getProductType(endpoint : any) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': this.auth,
        'token': this.token,
        'timezone': this.clientTimeZone
      })
    };
    return new Promise(resolve => {
      this.httpCli.get(endpoint, httpOptions)
        .subscribe(data => {
          const res = JSON.parse(JSON.stringify(data));
          resolve(res);
        });
    });

  }

  getClientProductByID(endpoint : any){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': this.auth,
        'token': this.token,
        'timezone': this.clientTimeZone
      })
    };
    return new Promise(resolve => {
      this.httpCli.get(endpoint, httpOptions)
        .subscribe(data => {
          const res = JSON.parse(JSON.stringify(data));
          resolve(res);
        });
    });
  }

  // saveSettings(endpoint: string, settings: any): Observable<any> {

  //   console.log(settings,'saveSettings service function insede..')
  //   // Adjust URL and request method as needed

  //   console.log('API URL::',endpoint);
  //   console.log('Settings Data::',settings);
  //   return this.httpCli.post<any>(endpoint, settings);
  // }


  saveSettings(endpoint: string, settings: any) {
    const headers = { 'timezone': this.clientTimeZone,
       'authorization': this.auth, 
       'Content-Type': 'application/json', 'token': this.token }
    return new Promise(resolve => {
      this.httpCli.post<any>(endpoint, settings, { headers:this.getHeaders() })
      .subscribe(data => {
        const result = JSON.parse(JSON.stringify(data));
        resolve(result);
      });
    });
  }

  async getDataV2(endpoint : any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': this.auth,
        'token': this.token,
        'timezone': this.clientTimeZone
      })
    };
    return new Promise((resolve, reject) => {
      this.httpCli.get(endpoint, httpOptions)
        .subscribe(
          data => {
            const res = JSON.parse(JSON.stringify(data));
            resolve(res);
          },
          error => {
            console.error('HTTP GET Error:', error);
            reject(error); // Reject promise if an error occurs
          }
        );
    });
  }
  async patchDataV2(endpoint : any,body: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'authorization': this.auth,
        'token': this.token,
        'timezone': this.clientTimeZone
      })
    };
    return new Promise((resolve, reject) => {
      this.httpCli.put(endpoint, body,httpOptions)
        .subscribe(
          data => {
            const res = JSON.parse(JSON.stringify(data));
            resolve(res);
          },
          error => {
            console.error('HTTP GET Error:', error);
            reject(error); // Reject promise if an error occurs
          }
        );
    });
  }
}


